import { jsx as a, jsxs as g } from "react/jsx-runtime";
import { twMerge as e } from "tailwind-merge";
import { InfoIcon as l } from "../../icons/info-icon.mjs";
const x = ({
  children: n,
  className: i,
  Icon: d = l,
  iconClassName: o,
  textClassName: m,
  style: r = "danger"
}) => /* @__PURE__ */ a(
  "div",
  {
    className: e(
      "relative flex flex-wrap items-center gap-1 rounded-lg border p-2 [&_a]:underline",
      r === "danger" && "border-danger bg-danger/10",
      r === "warn" && "border-yellow bg-warning-100",
      r === "info" && "border-brand-primary bg-brand-primary/10",
      i
    ),
    children: /* @__PURE__ */ g("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ a(
        d,
        {
          className: e(
            "shrink-0",
            r === "danger" && "fill-danger",
            r === "warn" && "fill-yellow",
            r === "info" && "fill-brand-primary",
            o
          )
        }
      ),
      /* @__PURE__ */ a(
        "span",
        {
          className: e(
            "flex flex-wrap gap-1 text-sm font-normal",
            r === "danger" && "text-danger",
            r === "warn" && "text-text-primary",
            r === "info" && "text-brand-primary",
            m
          ),
          children: n
        }
      )
    ] })
  }
);
export {
  x as SectionMessage
};
